import type { IUpdateRating } from '../../interfaces/request-update-rating-question.interface';
import { get } from 'svelte/store';
import { ApiTypes } from '../../enums/api.enum';
import {
  addApiError,
  addBusyApi,
  removeBusyApi,
} from '../../helpers/handle-api';
import { ConfigStore } from '../../store/config';
import { state_apiErrors } from '../../store/state';
import { trackedFetch } from '../../telemetry/tracked-fetch';

/** function to fetch PUT  /1/question/${questionId}/rating api end point */
export async function PutRating(
  params: Omit<IUpdateRating, 'questionId'>,
  questionId: string,
  signal: AbortSignal
): Promise<any> {
  if (!questionId?.trim()) {
    throw new TypeError('A question ID is required to submit a rating');
  }

  try {
    addBusyApi(ApiTypes.putRating);
    state_apiErrors.set(
      get(state_apiErrors).filter((x) => x.apiType !== ApiTypes.putRating)
    );

    let url = new URL(
      `${get(ConfigStore).apiBaseUrl}/1/question/${encodeURIComponent(questionId.trim())}/rating`
    );

    const tenantId = get(ConfigStore)?.serverConfig?.tenant_id ?? '';
    if (tenantId) url.searchParams.set('tenant', tenantId);

    return trackedFetch(tenantId, url.href, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
      body: JSON.stringify(params),
    })
      .then((res) => {
        if (res?.ok) return res;

        throw res;
      })
      .catch((res) => {
        /** error api */
        addApiError({
          apiType: ApiTypes.putRating,
          status: res?.status,
          statusText: res?.statusText,
          error: res?.error,
          errorType: res?.type,
        });

        throw res;
      })
      .finally(() => {
        removeBusyApi(ApiTypes.putRating);
      });
  } catch (e) {
    removeBusyApi(ApiTypes.putRating);
    throw e;
  }
}
